module.exports = __webpack_public_path__ + "img/ic-contact.a6904921.svg";